<template>
  <div class='orders'>
    <div class="row">
      <div class="col-6">
        <div class="files " v-if="order">
          <h3>文件列表</h3>
          <b-progress class="my-5" show-progress animated height="1rem" variant="primary" v-if="showProgress">
            <b-progress-bar :value="counter">
              上传中，已完成{{Math.round(counter)}} %
            </b-progress-bar>
          </b-progress>

          <table class='table table-sm'>
            <thead class='thead-default'>
              <th></th>
              <th>类型</th>
              <th>操作</th>
              <th>状态</th>
              <th>份数 X 大小</th>
              <th>页数</th>
              <th>文件名</th>
            </thead>
            <tbody>
              <tr v-for="(file, index) in files">
                <td>{{index + 1}}</td>
                <td>{{file.product_code}}</td>
                <td>
                  <button class="btn btn-sm btn-primary" @click="chooseFile" v-if="isAdmin || isPrinter">替换文件</button>
                  <form :action="`/api/files/{file.id}/pdf`" style="display:none" :file="file">
                    <input type="file" name="file" accept="application/pdf" v-on:change="validateAndUploadFile($event, file.filepath, file.id)">
                  </form>
                </td>
                <td>{{getOrderStatusDisplay(file.status)}}</td>
                <td>{{file.count}}份 X {{humanFileSize(file.size)}}</td>
                <td>{{file.page_count}}/{{file.page_count2}}</td>
                <td @click="copyTo"><a :href="'/media/' + file.filepath" target="_blank">{{file.filepath.split('/').pop()}}</a></td>
              </tr>
            </tbody>
          </table>
          
        </div>

        <div class=" my-5">
          <h3>打印任务列表</h3>
          <table class="table table-sm">
            <thead>
              <th>任务名</th>
              <th>任务类型</th>
            </thead>
            <tbody v-if="order">
              <tr v-for="task in order.meta.tasks">
                <td>
                  <router-link :to="`/tasks/${task.id}`">{{task.name}}</router-link>
                </td>
                <td>{{getTaskTypeDisplay(task.type)}}</td>
              </tr>

              <tr v-for="task in order.meta.revoked_tasks">
                <td>
                  <router-link :to="`/tasks/${task.id}`"><del>{{task.name}}</del></router-link>
                </td>
                <td><del>{{getTaskTypeDisplay(task.type)}}</del></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="single-order my-5" v-if="order">
          <order-operation :order="order" class=""></order-operation>
        </div>
      </div>
      <div class="col-6">
        <order-reworks :reworks="this.reworks"></order-reworks>
        <order-delivery :delivery="this.delivery"></order-delivery>
        <order-incomes class="mt-5 " :order-no="this.$route.params.order_no" v-if="isAdmin || isPrinter"></order-incomes>

        <div class="logging mt-5 ">
          <order-logs :order-no="this.$route.params.order_no" ref="orderLogsRef"></order-logs>  
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderMixin from '@/mixins/order'
import RoleMixin from '@/mixins/role'
import TaskMixin from '@/mixins/task'
import {humanFileSize, copyToClipboard} from '@/utils/tools'
import {showFailedAlert, showSuccessAlert} from '@/utils/alert'
import OrderOperation from '@/components/_order/OrderOperation'
import OrderIncomes from '@/components/_order/OrderIncomes'
import OrderLogs from '@/components/_order/OrderLogs'
import OrderReworks from '@/components/_order/OrderReworks'
import OrderDelivery from '@/components/_order/OrderDelivery'
import LocalTime from '@/components/_small/LocalTime'

function loadData () {
  // request order
  this.$http.get('/api/orders/' + this.$route.params.order_no).then(response => {
    this.order = response.data.data
    this.files = this.order.order_files
    this.reworks = this.order.reworks
    this.delivery = this.order.delivery
  })
  .catch(function (error) {
    console.log(error)
  })
}

function chooseFile (e) {
  e.target.parentElement.querySelector('input[type=file]').click()
}

function validateAndUploadFile (event, filepath, fileId) {
  // 验证文件名是否一致
  const serverFileName = filepath.split('/').pop()
  let target = event.target
  let file = target.files[0]
  if (file.name !== serverFileName) {
    showFailedAlert('文件名与被替换的不一致')
    return
  }

  let formData = new FormData()
  formData.append('file', file)

  this.max = file.size
  this.counter = 0
  this.showProgress = true
  this.$http.post(`/api/files/${fileId}/pdf`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: event => {
      this.counter = event.loaded / file.size * 100
    }
  }).then(response => {
    this.showProgress = false
    this.counter = 0
    showSuccessAlert('文件上传完毕')
    this.$refs.orderLogsRef.loadData()
  })
}

function copyTo (event) {
  let text = event.target.innerText
  copyToClipboard(text.split('.pdf')[0])
  showSuccessAlert('已复制文件名到剪切板')
}

export default {
  name: 'order',
  mixins: [OrderMixin, RoleMixin, TaskMixin],
  components: {
    OrderOperation,
    LocalTime,
    OrderIncomes,
    OrderLogs,
    OrderReworks,
    OrderDelivery
  },
  data () {
    return {
      counter: 0,
      showProgress: false,
      order: null,
      files: [],
      reworks: null,
      order_shipper: null,
      delivery: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    humanFileSize,
    loadData,
    chooseFile,
    validateAndUploadFile,
    copyToClipboard,
    copyTo
  }
}
</script>
